import useResponsive from "@/hooks/useResponsive.hook";
import { Icon } from "@nexus/shared-ui";
import { Button, Col, Popover, Row, Tooltip, Typography } from "antd";
import clsx from "clsx";
import { useState } from "react";
import { useTranslation } from "react-i18next";

export type ConfirmButtonVariant = "danger" | "primary" | "success";

interface IConfirmPopoverButton {
  item: any;
  onConfirm: (item: any) => void;
  disabled?: boolean;
  withTitle?: boolean;
  className?: string;
  onClickAction?: (e: any) => void;
  iconSize?: number;
  iconName?: string;
  iconColor?: string;
  variant?: ConfirmButtonVariant;
  confirmTextKey?: string;
  buttonTextKey?: string;
  tooltipKey?: string;
}

const { Text } = Typography;

const ConfirmPopoverButton = ({
  item,
  onConfirm,
  disabled,
  withTitle,
  className = "",
  onClickAction,
  iconSize = 16,
  iconName = "UilTrashAlt",
  iconColor,
  variant = "danger",
  confirmTextKey = "actions.deleteConfirm",
  buttonTextKey = "actions.delete",
  tooltipKey,
}: IConfirmPopoverButton) => {
  const { t } = useTranslation();
  const [open, setOpen] = useState(false);
  const isResponsive = useResponsive();

  const hide = () => {
    setOpen(false);
  };

  const handleOpenChange = (newOpen: boolean) => {
    setOpen(newOpen);
  };

  const resolvedIconColor =
    iconColor || (variant === "danger" ? "danger" : "primary");

  const button = (
    <Button
      className={clsx(
        "d-flex align-items-center",
        {
          "ant-btn-icon-only": !withTitle,
        },
        className
      )}
      icon={
        <Icon name={iconName as any} size={iconSize} color={resolvedIconColor} />
      }
      type="link"
      danger={variant === "danger"}
      disabled={disabled}
      onClick={onClickAction ? onClickAction : () => {}}
    >
      {withTitle ? <Text>{t(buttonTextKey)}</Text> : null}
    </Button>
  );

  return (
    <Popover
      content={
        <Row gutter={[8, 8]}>
          <Col span={24}>
            <Row align={"middle"}>
              <Icon name="UilInfoCircle" color="warning" size={16} />
              <Text className="px-1">{t(confirmTextKey)}</Text>
            </Row>
          </Col>
          <Col span={24}>
            <Row justify={"end"}>
              <Button size="small" className="mx-2" onClick={hide}>
                {t("actions.no")}
              </Button>
              <Button
                type="primary"
                size="small"
                onClick={(e) => {
                  e.stopPropagation();
                  setOpen(false);
                  onConfirm(item);
                }}
              >
                {t("actions.yes")}
              </Button>
            </Row>
          </Col>
        </Row>
      }
      placement="bottomLeft"
      open={open}
      onOpenChange={handleOpenChange}
      trigger="click"
    >
      {tooltipKey ? <Tooltip title={t(tooltipKey)}>{button}</Tooltip> : button}
    </Popover>
  );
};

export default ConfirmPopoverButton;
